import { patientApi } from '@/api/PatientApi'
import type { PatientBillingRecord } from '@/api/types/PatientApi'
import { useQuery } from '@tanstack/react-query'

const useFetchBillingRecord = () => {
	const { data = {} as PatientBillingRecord, isLoading } = useQuery({
		queryKey: ['patient-billing'],
		queryFn: () => patientApi.getBillingRecord(),
		staleTime: 30000,
	})

	return {
		billingRecord: data,
		isLoading,
	}
}

export { useFetchBillingRecord }
